import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { withViewport } from '../../util/uiHelpers';
import { useConfiguration } from '../../context/configurationContext';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import css from './HowItWorksPage.module.css';

//Static assets
import facebookImage from '../../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../../assets/biketribe-twitter-sharing-600x314.jpg';

//Section pages
import routeConfiguration from '../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import SectionHero from './Sections/SectionHero';
import SectionFeatures from './Sections/SectionFeatures';
import SectionSellers from './Sections/SectionSellers';
import SectionBuyers from './Sections/SectionBuyers';
import SectionBestMarketplace from './Sections/SectionBestMarketplace';
import SectionShipping from './Sections/SectionShipping';
import SectionPayment from './Sections/SectionPayment';

export const HowItWorksPageComponent = props => {
  const { intl, scrollingDisabled, history, listings, viewport } = props;

  const config = useConfiguration();
  const marketplaceName = config.marketplaceName;

  const schemaTitle = intl.formatMessage({ id: 'HowItWorksPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({
    id: 'HowItWorksPage.schemaDescription',
  });
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;

  const useHistoryPush = (page, params = {}) =>
    history.push(createResourceLocatorString(page, routeConfiguration(), {}, params));

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <SectionHero intl={intl} viewport={viewport} history={history} />
          <SectionFeatures intl={intl} />
          <SectionSellers intl={intl} history={history} />
          <SectionBuyers intl={intl} />
          <SectionBestMarketplace intl={intl} />
          <SectionShipping intl={intl} />
          <SectionPayment intl={intl} history={history} />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

HowItWorksPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({});

const HowItWorksPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withViewport,
  injectIntl
)(HowItWorksPageComponent);

export default HowItWorksPage;